import { render, staticRenderFns } from "./PurchaseOrderDatatable.vue?vue&type=template&id=64616e2b"
import script from "./PurchaseOrderDatatable.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports